import {
  DELETE_EVENT,
  EDIT_EVENT,
  LOADING_EVENT_SUCCESS,
  LOADING_EVENT_START,
  LOAD_EVENTS,
  SET_ERROR,
  CLEAR_ERROR,
  SAVE_SUCCESS,
  LOAD_FACILITIES,
  SAVE_NOT,
  LOAD_EMPLOYEES,
  SET_RECENT_DATE,
  LOAD_WORKTYPE_EMPLOYEES,
  LOAD_LATEST_SELECTED_EVENT_DATA,
  PATCH_EDITED_EVENT,
  LOAD_WORK_TYPES,
} from "../types/schedule.types";

import { IPeople } from "./people.reducer";

export interface IScheduleEvent {
  id: string;
  facility: string;
  sub_facility?: string;
  created_by_id: string;
  assigned_to_id: string | null;
  work_type: string;
  schedule_date: string;
  start_time: string;
  end_time: string;
  schedule_status: number;
  schedule_note?: string;
  occupancy: boolean;
  assigned_to: IPeople | null;
  employee: string;
  created_at: string;
  new_schedule: string;
}

export type workType = {
  id: string;
  work_type: string;
};
export type workTypeOption = {
  id: string;
  name: string;
};

export type employeeScheduleType = {
  id: string;
  fullname: string;
  username: string;
  email: string;
  is_superuser: boolean;
  address: string;
  mobile_number: string;
  date_of_birth: string;
  avatar: string;
};

export type scheduleFacilityType = {
  id: string;
  facility_name: string;
  depth: number;
  parent: string | null;
  childCategories: [scheduleFacilityType];
  workTypes: [];
};

export type scheduleStateType = {
  loading: boolean;
  events: IScheduleEvent[];
  facilities: scheduleFacilityType[];
  work_types: workTypeOption[];
  employees: employeeScheduleType[];
  worktype_employees: employeeScheduleType[];
  error: null | string;
  save: boolean;
  recentScheduleDate: string | null;
  latestSelectedEventData: IScheduleEvent | null;
};

export type actionType = {
  type: string;
  payload?: any;
};

let initialState: scheduleStateType = {
  loading: true,
  events: [],
  facilities: [],
  work_types: [],
  employees: [],
  worktype_employees: [],

  error: null,
  save: false,
  recentScheduleDate: null,
  latestSelectedEventData: null,
};

export default function scheduleReducer(
  state: scheduleStateType = initialState,
  action: actionType
) {
  switch (action.type) {
    case LOAD_EVENTS:
      return { ...state, events: action.payload };
    case LOAD_FACILITIES:
      return { ...state, facilities: action.payload };
    case LOAD_WORK_TYPES:
      return { ...state, work_types: action.payload };
    case LOAD_EMPLOYEES:
      return { ...state, employees: action.payload };
    case LOAD_WORKTYPE_EMPLOYEES:
      return { ...state, worktype_employees: action.payload };
    case EDIT_EVENT:
      return state;
    case LOADING_EVENT_START:
      return { ...state, loading: true };
    case LOADING_EVENT_SUCCESS:
      return { ...state, loading: false };

    case SET_RECENT_DATE: {
      return;
    }
    case LOAD_LATEST_SELECTED_EVENT_DATA: {
      return {
        ...state,
        latestSelectedEventData: action.payload,
      };
    }
    case SET_ERROR:
      return {
        ...state,
        error: action.payload ?? "Error occured in schedule events",
      };
    case CLEAR_ERROR:
      return { ...state, error: null };
    case DELETE_EVENT:
      return {
        ...state,
        events: state.events.filter((event) => {
          return event.id !== action?.payload;
        }),
      };
    case SAVE_NOT:
      return { ...state, save: false };
    case SAVE_SUCCESS:
      return { ...state, save: true };
    case PATCH_EDITED_EVENT:
      return {
        ...state,
        events: state.events.map((event) => {
          if (event.id === action?.payload?.id) {
            return action.payload;
          } else {
            return event;
          }
        }),
      };

    default:
      return state;
  }
}
